import React from "react";
import { Route } from "react-router-dom";
import UsersPage from "./account/components/Users/UsersPage";
import RequestPage from "./support/RequestPage";
import CustomersPage from "./account/components/Customers/CustomersPage";

export const settingsRoutes = [
    <Route key="users" path="/account/users" element={<UsersPage />} />,
    <Route key="request" path="/support/request" element={<RequestPage />} />,
    <Route key="users" path="/account/customers" element={<CustomersPage />} />,
];